import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/styles/globals.scss';
import { routes } from './routing/routes.tsx';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { App } from 'antd';
import { NotificationProvider } from './components/notification-provider/notification-provider';


const router = createBrowserRouter(routes, {
  future: {
    v7_fetcherPersist: true,
    v7_normalizeFormMethod: true,
    v7_partialHydration: true,
    v7_relativeSplatPath: true,
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App>
      <NotificationProvider>
        {/* <ErrorBoundary> */}
          <RouterProvider
            future={{
              v7_startTransition: true,
            }}
            router={router}
          />
        {/* </ErrorBoundary> */}
      </NotificationProvider>
    </App>
  </React.StrictMode>
);
